module.exports = __webpack_public_path__ + "static/tkodes-circle.88a8019c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tkodes-circle.jpg
// module id = 362
// module chunks = 35783957827783